import { MutationResult, useMutation } from '@apollo/client';
import { ExecutionResult } from 'graphql';

import {
  CreateVideoStoryMutation,
  CreateVideoStoryMutationVariables,
  VideoStory,
} from '../../../types/__generated__';
import useBasePageQuery from '../useBasePageQuery';
import useFullPageQuery from '../useFullPageQuery';
import createVideoStory from './queries/createVideoStory.gql';
import getVideoStory from './queries/getVideoStory.gql';

export default function useVideoStory(): [
  (input: any) => Promise<ExecutionResult<CreateVideoStoryMutation>>,
  MutationResult<CreateVideoStoryMutation>,
  Boolean,
  VideoStory?,
] {
  const { data } = useBasePageQuery();

  const { data: videoStory, loading } = useFullPageQuery<any>(getVideoStory, {
    notifyOnNetworkStatusChange: true,
    context: {
      credentials: 'include',
    },
    variables: { legacyId: data?.page?.legacyId },
  });

  const [runMutation, mutationResult] = useMutation<
    CreateVideoStoryMutation,
    CreateVideoStoryMutationVariables
  >(createVideoStory, {
    context: {
      credentials: 'include',
    },
    refetchQueries: [
      {
        query: getVideoStory,
        variables: {
          legacyId: data?.page?.legacyId,
        },
        context: {
          credentials: 'include',
        },
      },
    ],
  });

  const createVideoStoryEntry = (input: any) =>
    runMutation({
      variables: {
        input: {
          userName: input.userName,
          pageTitle: input.pageTitle,
          pageStatement: input.pageStatement,
          pageGuid: input.pageGuid,
          donationTotal: input.donationTotal,
          currency: input.currency,
          imageUrls: input.imageUrls,
          fitness: input.fitness,
          charityLogoUrl: input.charityLogoUrl,
        },
      },
    });

  return [
    createVideoStoryEntry,
    mutationResult,
    loading,
    videoStory?.getVideoStory,
  ];
}
